import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHotDrinkCup: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconHotDrinkCup"><Path fillRule="evenodd" clipRule="evenodd" d="M5.97467 2H18.0253L19.1163 5H21V9.5H19.9558L18.7653 22H5.23459L4.04614 9.5H3V5H4.8838L5.97467 2ZM6.47989 5H17.5202L16.9747 3.5H7.02533L6.47989 5ZM19.5 8V6.5H4.5V8H19.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHotDrinkCup;
